import { WeddingConfig } from '../types';
import weddingConfigData from '../data/wedding-config.json';

export const getWeddingConfig = (): WeddingConfig => {
  return weddingConfigData as WeddingConfig;
};